// extracted by mini-css-extract-plugin
export var locationCard = "_ie-0";